import { render, staticRenderFns } from "./AgreementPrivacy.vue?vue&type=template&id=1d408670&scoped=true"
import script from "./AgreementPrivacy.vue?vue&type=script&lang=js"
export * from "./AgreementPrivacy.vue?vue&type=script&lang=js"
import style0 from "./AgreementPrivacy.vue?vue&type=style&index=0&id=1d408670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d408670",
  null
  
)

export default component.exports